export const LEVELS = {
  HEIGHT: 'HIGHT',
  ELEVATED: 'ELEVATED',
  MEDIUM: 'MEDIUM',
  LOW: 'LOW',
};
